import React from 'react';
import $ from "jquery";

import { MarkerIcon } from './map-icon';

const Marker = ({ text, setCurrentId, currentId  }) => {
  const handleClick = (e) => {
    // console.log("xxx1",e.currentTarget.dataset.myobjid)
    // console.log("xxx1",document.getElementById(e.currentTarget.dataset.myobjid))
    setCurrentId(e.currentTarget.dataset.myobjid)
    // document.getElementById(e.currentTarget.dataset.myobjid).scrollTo(0,0)
    $("html, body").animate({ scrollTop: $('#'+e.currentTarget.dataset.myobjid).offset().top - 110 }, 1000);

    // $('html, body').animate({
    //     scrollTop: $(e.currentTarget.dataset.objectid).offset().top
    // }, 500);

    $('#'+e.currentTarget.dataset.myobjid).addClass("active").siblings().removeClass("active")
    //$(".map-marker-"+hit.objectID).addClass("active").siblings().removeClass("active")
  }
  const greatPlaceStyle = {
    position: 'absolute',
    transform: 'translate(-75%, -75%)'
  }
  return (
    <div style={greatPlaceStyle} className="marker" data-myobjid={text} onClick={handleClick} role="presentation">
      {text != "noProp" &&
        <MarkerIcon active={text == currentId}/>
      }
    </div>
  )
}

export default Marker;
